import React, { useState, useEffect, useRef } from 'react';
import upArrow from "../../Images/up.png"; // Import up arrow image
import downArrow from "../../Images/down.png"; // Import down arrow image
import { useTranslation } from 'react-i18next';

const BookingSelect = ({ setSelectedService,packageLength ,servicesLength}) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const isArabic = currentLanguage === "ar";
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState('packages');
    const [hoveredItem, setHoveredItem] = useState(null); // Track the hovered item
    const [arrow, setArrow] = useState(downArrow); // Default arrow to down

    const dropdownRef = useRef(null); // For the dropdown list
    const selectRef = useRef(null); // For the select button

    // Close the dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                selectRef.current && !selectRef.current.contains(event.target) &&
                dropdownRef.current && !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
                setArrow(downArrow); // Reset to down arrow when closing dropdown
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (value) => {
        setSelectedOption(value);
        setSelectedService(value); // Set the selected service
        setShowDropdown(false); // Close the dropdown
        setArrow(downArrow); // Reset to down arrow after selection
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
        setArrow(showDropdown ? downArrow : upArrow); 
    };
console.log("packageLength",packageLength)
    return (
        <div 
            style={{
                ...styles.customSelect,
                borderColor: showDropdown ? '#BABABA' : '#BABABA', // Change border color when dropdown is open
                backgroundColor: showDropdown ? '#E8E8E8' : '#E8E8E8', // Change background color when dropdown is open
                transition: 'all 0.3s ease', // Smooth transition
            }} 
            ref={selectRef} 
            onClick={toggleDropdown}
        >
         {isArabic ?    <>
        <div style={styles.selectButton}>
  {selectedOption == 'packages' ? 
    <>
      {t('packages')} {packageLength && packageLength != 0 ? <span style={{margin:"0 5px"}}> ({packageLength})</span>  : ""}
    </>
    : 
    <>
      {t('services')} {servicesLength && servicesLength != 0 ? <span style={{margin:"0 5px"}}> ({servicesLength})</span> : ""}
    </>
  }
</div>

            <div>
                <img 
                    src={arrow} 
                    alt="arrow" 
                    style={{
                        ...styles.arrow,
                        transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)', // Rotate arrow when dropdown is open
                        transition: 'transform 0.3s ease',
                    }} 
                />
            </div>
            </> :  
            <>
            <div style={{margin:"20px"}}>
                <img 
                    src={arrow} 
                    alt="arrow" 
                    style={{
                        ...styles.arrow,
                        transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)', // Rotate arrow when dropdown is open
                        transition: 'transform 0.3s ease',
                    }} 
                />
            </div>

            <div style={styles.selectButton}>
  {selectedOption == 'packages' ? 
    <>
      {packageLength && packageLength != 0 ? <span style={{margin:"0 5px"}}> ({packageLength})</span>  : ""}  {t('packages')}
    </>
    : 
    <>
      {servicesLength && servicesLength != 0 ? <span style={{margin:"0 5px"}}> ({servicesLength})</span> : ""}  {t('services')}
    </>
  }
</div>
            </>

            
            
            }

            {showDropdown && (
                <ul 
                    style={{
                        ...styles.optionsList,
                        maxHeight: showDropdown ? '150px' : '0', // Animate maxHeight for smooth opening/closing
                        opacity: showDropdown ? 1 : 0, // Fade in/out
                        justifyContent: isArabic ? "start" : "end",
                        transition: 'all 0.3s ease', // Smooth transition
                        
                    }} 
                    ref={dropdownRef}
                >
                    {selectedOption == 'services' && (
                        <li 
                            style={{
                                ...styles.optionItem, 
                                backgroundColor: hoveredItem == t('packages') ? '#b49345' : 'transparent',
                                color: hoveredItem == t('packages') ? '#fff' : '',
                            }} 
                            onClick={() => handleSelect( 'packages')}
                            onMouseEnter={() => setHoveredItem('packages')}
                            onMouseLeave={() => setHoveredItem(null)}
                        >
                           { t('packages')}
                        </li>
                    )}
                    {selectedOption == 'packages' && (
                        <li 
                            style={{
                                ...styles.optionItem, 
                                backgroundColor: hoveredItem == t('services') ? '#b49345' : 'transparent',
                                color: hoveredItem == t('services') ? '#fff' : '',
                            }} 
                            onClick={() => handleSelect('services')}
                            onMouseEnter={() => setHoveredItem('services')}
                            onMouseLeave={() => setHoveredItem(null)}
                        >
                            { t('services')}
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

const styles = {
    customSelect: {
        position: 'relative',
        width: '100%',
        border: '2px solid #D1D1D1',
        direction: "rtl",
        height: "60px",
        borderRadius: "8px",
        cursor: 'pointer',
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontWeight: "800",
        fontSize: "1.3em",
        color: "#b49345",
    },
    selectButton: {
        // backgroundColor: '#fff',
        padding: '10px',
        borderRadius: '4px',
        cursor: 'pointer',
        margin: "0 50px",
        display: "flex",
        alignItems: "center",
    },
    optionsList: {
        position: 'absolute',
        width: '100%',
        backgroundColor: '#E8E8E8',
        margin: 0,
        marginTop: "120px",
        padding: 0,
        listStyle: 'none',
        border: '2px solid #b49345',
        borderRadius: '8px',
        maxHeight: '0', // Initially hidden
        overflowY: 'auto',
        zIndex: 999,
        display:"flex",
        
    },
    optionItem: {
        padding: '10px',
        cursor: 'pointer',
        padding:"10px 50px",
        width:"100%"
    },
    arrow: {
        marginLeft: '10px',
        width: '16px',
        height: '16px',
    },
};

export default BookingSelect;
